import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column, Row } from "simple-flexbox";
import CheckIcon from "@material-ui/icons/Check";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { addTraining } from "../../actions/master-data/training_actions";
import { renderFile } from "../../components/form/FormComponent";
import {
    getTrainingAdd,
    getTrainingAddPending,
    getTrainingAddError
} from "../../reducers/master-data/training_reducer";

class ModalPenerbitanSurat extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show && this.props.show === true) {
            this.props.reset();
        }
    }

    handleSubmit(values) {
        // const { addTraining, onHide, handleRefresh } = this.props;
        // const param = {
        // };

        // const callback = () => {
        //     onHide();
        //     handleRefresh();
        // };
        // addTraining(param, callback);
    }

    render() {
        const {
            handleSubmit,
            show,
            onHide,
            addTraining_pending
        } = this.props;
        let currentYear = new Date().getFullYear();
        let yearOptions = [];
        for (let i = currentYear; i >= 1957; i--) {
            yearOptions = [...yearOptions, { label: i, value: i }];
        }
        return (
            <Modal
                show={show}
                onHide={onHide}
                cityOption={this.props.cityOption}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <p style={{ fontSize: 20, fontWeight: 600 }}>Penerbitan Surat Rekomendasi</p>
                </Modal.Header>
                <Modal.Body>
                    <form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        style={{ width: "100%" }}
                    >
                        <Column
                            vertical="center"
                            horizontal="stretch"
                            className={css(styles.bodyModal)}
                        >
                            <span style={{ marginBottom: 15 }}>Untuk melakukan penerbitan surat perlu mengunggah surat rekomendasi yang akan diterbitkan</span>
                            {(
                                <>
                                    <Field
                                        type="file"
                                        name="berkas"
                                        fileType="image"
                                        message="Doc, Docx"
                                        title="SURAT REKOMENDASI"
                                        component={renderFile}
                                    />
                                </>
                            )}
                        </Column>
                        <Row
                            horizontal="flex-end"
                            vertical="center"
                            className={css(styles.footerModal)}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={addTraining_pending}
                                className={css(styles.approveButton)}
                                startIcon={
                                    addTraining_pending ? (
                                        <CircularProgress size={14} color="secondary" />
                                    ) : (
                                            <CheckIcon />
                                        )
                                }
                            >
                                simpan
                            </Button>
                        </Row>
                    </form>
                </Modal.Body>
            </Modal>
        );
    }
}

const styles = StyleSheet.create({
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        marginRight: 10,
        color: "#495057",
        boxShadow: "none",
    },
    footerModal: {
        backgroundColor: "#FBFBFD",
        padding: "20px 40px",
    },
    bodyModal: {
        padding: "0px 40px 20px",
        width: "100%",
    },
});

function validate(values) {
    const { berkas } = values;
    const errors = {};
    if (!berkas) {
        errors.berkas = "Berkas tidak boleh kosong!";
    }
    return errors;
}

ModalPenerbitanSurat = reduxForm({
    form: "ModalPenerbitanSurat",
    validate: validate,
    shouldError: () => true,
    enableReinitialize: true,
})(ModalPenerbitanSurat);

function mapStateToProps({ addTraining }) {
    return {
        addTraining_pending: getTrainingAddPending(addTraining),
        addTraining_data: getTrainingAdd(addTraining),
        addTraining_error: getTrainingAddError(addTraining),
    };
}

export default connect(mapStateToProps, {
    addTraining,
})(withRouter(ModalPenerbitanSurat));